import {Component, OnInit, ViewChild} from '@angular/core';
import {JhiEventManager} from './Services/event-manager.service';
import {AccountService} from './core/auth/account.service';
import {Account} from './core/user/account.model';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {LoginService} from './core/login/login.service';
import {LoginModalService} from './core/login/login-modal.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  account: Account;
  modalRef: NgbModalRef;

  @ViewChild('myModal') myModal;

  constructor(
    translate: TranslateService,
    private loginService: LoginService,
    private loginModalService: LoginModalService,
    private accountService: AccountService,
    private eventManager: JhiEventManager
  ) {
    translate.setDefaultLang('en');
  }

  ngOnInit() {
    this.accountService.identity().then((account: Account) => {
      this.account = account;
    });
    this.registerAuthenticationSuccess();
    this.registerPreAuthListener();
  }

  registerAuthenticationSuccess() {
    this.eventManager.subscribe('authenticationSuccess', message => {
      this.accountService.identity().then(account => {
        this.account = account;
      });
    });
  }

  isAuthenticated() {
    return this.accountService.isAuthenticated();
  }

  login() {
    this.modalRef = this.loginModalService.open();
  }

  private registerPreAuthListener() {
    this.eventManager.subscribe('triggerAuthentication', response => this.openLoginModal());
  }

  private openLoginModal() {
    this.login();
  }


}
